import { AfterContentInit, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ICardListGridViewMetadata } from "@tylertech/tyler-api-types";
import { Utilities } from "@tylertech/shared-module";
import { MetadataEventService } from "../../../services";
import { RepositoryFormData } from "../../../interfaces";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

export interface CardGroup
{
    Index: number;
    Group: string;
    Groups: CardGroup[];
    Entities: any[];
    Count: number;
    Open: boolean;
}

@Component({
    selector: "card-list",
    templateUrl: "./cardList.tmpl.html",
    standalone: false
})
export class CardListComponent implements AfterContentInit
{
    @Input()
    view: ICardListGridViewMetadata;

    @Input()
    entities: any[];

    @Input()
    datacontroller: RepositoryFormData;

    @Input()
    showHeader: boolean;

    @Input()
    viewTitle: string;

    groups: CardGroup[] = [];

    grouped: boolean;

    constructor(private $metadataEventService: MetadataEventService)
    {
        const self = this;
        this.$metadataEventService.onRecalculateWorking.pipe(takeUntilDestroyed())
            .subscribe(args =>
            {
                if (!args.Recalculating)
                    self.buildGroups();
            });
    }

    ngAfterContentInit(): void
    {
        this.grouped = !Utilities.IsNullOrUndefinedOrEmpty(this.view.GroupByProperties);
        this.buildGroups();
    }

    get hasBody(): boolean
    {
        return this.view.Card.ViewMetaData.Properties.length > 0;
    }

    buildGroups()
    {
        this.groups = [];
        this.entities.forEach(entity =>
        {
            this.setElements(entity);

            let nextGroup = this.groups;
            if (this.grouped)
            {
                this.view.GroupByProperties.forEach((group, index) =>
                {
                    nextGroup = this.buildGroup(nextGroup, entity[group], entity, index === this.view.GroupByProperties.length - 1);
                });
            }
        });
    }

    buildGroup(groupList: CardGroup[], groupName: string, entity: any, last: boolean): CardGroup[]
    {
        if (!last)
        {
            let currentGroup = groupList.find(x => x.Group === groupName);
            if (!currentGroup)
            {
                currentGroup = <CardGroup>{Group: groupName, Groups: [], Count: 0};
                groupList.push(currentGroup);
            }
            if (entity["$cardVisible"])
                currentGroup.Open = true;
            currentGroup.Count++;
            return currentGroup.Groups;
        }
        else
        {
            let currentGroup = groupList.find(x => x.Group === groupName);
            if (!currentGroup)
            {
                currentGroup = <CardGroup>{Group: groupName, Entities: [], Count: 0};
                groupList.push(currentGroup);
            }
            if (entity["$cardVisible"])
                currentGroup.Open = true;
            currentGroup.Entities.push(entity);
            currentGroup.Count++;
            return null;
        }
    }

    setElements(model: any): void
    {
        model["$title"] = this.view.Card.TitleProperty ? model[this.view.Card.TitleProperty] : this.view.Card.Title;
        model["$emblemText"] = this.view.Card.EmblemTextProperty ? model[this.view.Card.EmblemTextProperty] : this.view.Card.EmblemText;
    }

    expand()
    {
        this.applyToChildren(this.groups, true);
    }

    collapse()
    {
        this.applyToChildren(this.groups, false);
    }

    applyToChildren(groups: CardGroup[], expand: boolean): void
    {
        groups.forEach(group =>
        {
            group.Open = expand;
            if (group.Groups)
                this.applyToChildren(group.Groups, expand);
        });
    }

}
